let activeCollection = null;
document.addEventListener("DOMContentLoaded", () => {
	listener('click', '.catalog-collect--list-item', (el, e) => {
		let container = el.closest('.catalog-collections');

		let all = container.querySelector('.catalog-collect--all');
		if (all) {
			all.classList.remove('active');
		}

		container.querySelectorAll('.catalog-collect--list-item').forEach((item) => {
			item.classList.remove('active');
		})

		el.classList.add('active');

		activeCollection = el.dataset.index;
	});

	listener('click', '.catalog-collect--all', (el, e) => {
		el.classList.add('active');

		let container = el.closest('.catalog-collections');
		container.querySelectorAll('.catalog-collect--list-item').forEach((item) => {
			item.classList.remove('active');
		});

		activeCollection = null;
	});
});

document.addEventListener('turbo:render', (event) => {
	if (event.target?.hasAttribute('data-turbo-preview') === true) return;

	let catalogCollect = document.getElementById('catalog-collect');
	if (catalogCollect) {
		let index = activeCollection;
		if (index !== null) {
			catalogCollect.swiper?.slideTo(index-1);
		}
	}
});
